import { createDraftSafeSelector, createSlice } from '@reduxjs/toolkit'
import { getTours, addTour, removeTour, editTour, getTourCategories, deactivateTourThunk, forceDeleteTour } from './thunks'
import { formatTourToObject } from '../../util/util'


const initialState = {
  tours: [],
  categories: [],
  error: null,
  status: 'idle',
  lastFetched: null,
}

export const tourSlice = createSlice({
  name: 'tours',
  initialState,
  reducers: {
    resetTourStatus: (state) => { state.status = 'idle'; state.lastFetched = null; },
  },
  extraReducers: (builder) => {

    builder.addCase(getTours.pending, (state, action) => {
      state.status = 'loading'
    })

    builder.addCase(getTours.fulfilled, (state, action) => {
      state.tours = (action.payload || []).map(e => formatTourToObject(e))
      state.status = 'successful'
      state.lastFetched = Date.now()
    })

    builder.addCase(getTours.rejected, (state, action) => {
      state.status = 'failed'
      state.error = action.error
    })

    builder.addCase(addTour.fulfilled, (state, action) => {
      if (action.payload) {
        state.tours.push(formatTourToObject(action.payload))
      }
    })

    builder.addCase(removeTour.fulfilled, (state, action) => {
      const payload = action.payload;
      // If the tour was deleted cleanly (no reservations), remove from state
      if (payload?.deleted) {
        state.tours = state.tours.filter(e => e.id !== payload.id);
      }
      // If blocked, we keep the tour in the list — UI will show the conflict modal
    })

    // Soft-delete: filter from catalog (it's now is_active=false)
    builder.addCase(deactivateTourThunk.fulfilled, (state, action) => {
      state.tours = state.tours.filter(e => e.id !== action.payload);
    })

    // Force delete: also remove from catalog
    builder.addCase(forceDeleteTour.fulfilled, (state, action) => {
      const payload = action.payload;
      if (payload?.deleted) {
        state.tours = state.tours.filter(e => e.id !== payload.id);
      }
    })

    builder.addCase(editTour.fulfilled, (state, action) => {
      const payload = action.payload
      if (payload && payload.id) {
        state.tours = state.tours.map(e => e.id === payload.id ? formatTourToObject(payload) : e)
      }
    })

    // Tour Categories
    builder.addCase(getTourCategories.fulfilled, (state, action) => {
      state.categories = action.payload || []
    })

  }
})

export const toursFormattedSelector = (state) => state.tour.tours
export const tourCategoriesSelector = (state) => state.tour.categories

export const tourOptionsSelector = createDraftSafeSelector(
  toursFormattedSelector,
  (state) => state.map(element => ({ label: element.name, value: element.id })),
)



export const { resetTourStatus } = tourSlice.actions;

export default tourSlice.reducer